// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-user-data-icon {
  font-size: 25px;
  margin: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/structure-table-anagraph/structure-table-anagraph.component.scss","webpack://./src/components/general%20components/structure-table-anagraph/structure-table-anagraph.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;ACCF","sourcesContent":[".menu-user-data-icon {\n  font-size: 25px;\n  margin: 15px;\n}\n",".menu-user-data-icon {\n  font-size: 25px;\n  margin: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
